import { TRACK_PROGRAM_SPLIT_CHANGE_EVENT, loadTrackProgramSplitMap } from './trackProgramSplitStorage';

export type TrackProgramMode = 'unified' | 'split' | 'sync';

function v2Key(workspaceId: string, gradeId: string): string {
  return `cp.trackProgramMode.v2.${workspaceId}.${gradeId}`;
}

function isMode(v: unknown): v is TrackProgramMode {
  return v === 'unified' || v === 'split' || v === 'sync';
}

/**
 * v2 맵이 없으면 v1 boolean(편제별=false / 시간표별=true)을 unified/split 으로 마이그레이션해 반환합니다.
 */
export function loadTrackProgramModeMap(workspaceId: string, gradeId: string): Record<string, TrackProgramMode> {
  if (!workspaceId || !gradeId) return {};
  try {
    const raw = window.localStorage.getItem(v2Key(workspaceId, gradeId));
    if (raw) {
      const parsed = JSON.parse(raw) as unknown;
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        const out: Record<string, TrackProgramMode> = {};
        Object.entries(parsed as Record<string, unknown>).forEach(([trackName, val]) => {
          if (!trackName.trim()) return;
          if (isMode(val)) out[trackName] = val;
        });
        if (Object.keys(out).length > 0) return out;
      }
    }
    const v1 = loadTrackProgramSplitMap(workspaceId, gradeId);
    const migrated: Record<string, TrackProgramMode> = {};
    Object.entries(v1).forEach(([trackName, enabled]) => {
      if (!trackName.trim()) return;
      migrated[trackName] = enabled === true ? 'split' : 'unified';
    });
    return migrated;
  } catch {
    return {};
  }
}

export function saveTrackProgramModeMap(
  workspaceId: string,
  gradeId: string,
  value: Record<string, TrackProgramMode>
): void {
  if (!workspaceId || !gradeId) return;
  try {
    const storageKey = v2Key(workspaceId, gradeId);
    const serialized = JSON.stringify(value);
    if (window.localStorage.getItem(storageKey) === serialized) return;
    window.localStorage.setItem(storageKey, serialized);
    window.dispatchEvent(new CustomEvent(TRACK_PROGRAM_SPLIT_CHANGE_EVENT));
  } catch {
    /* ignore quota */
  }
}

/** 해당 학년(편제)에 동기화(sync) 모드 시간표가 하나라도 있으면 true */
export function gradeHasSyncTimetableProgram(workspaceId: string, gradeId: string): boolean {
  const ws = workspaceId.trim();
  const gid = gradeId.trim();
  if (!ws || !gid) return false;
  const map = loadTrackProgramModeMap(ws, gid);
  return Object.values(map).some((mode) => mode === 'sync');
}
